module.exports = "/_next/static/images/gurugaon_curry-3fb2432250acb432d594e577167b69e9.jpg";